import React from 'react';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { settingsFunctions } from '../../../../functions/settings';
import { useAuth } from '../../../../utils/Auth';
import './BottomCard.css';

function BottomCard(props) {
    const { accountType, profile_theme, messaging, buttons, setButtonState, setButtonToEdit, setShowForm, permissions, uid } = props;
    const { updateVcardObject, buttonsActiveState, getSocialUserHandle } = settingsFunctions;
    const { getUpdatedUserVcard } = useAuth();

    const style = {
        cursor: permissions.edit_button ? 'pointer' : 'default'
    };

    // ------------------ Edit Button -------------------//
    const editButton = (btn) => {
        setButtonToEdit(btn);
        setShowForm('edit-button');
    };

    //------------------- Drag and Drop -----------------//

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = async (result) => {
        if (!result.destination || (result.destination.index === result.source.index)) {
            return;
        };

        const items = reorder(
            buttons,
            result.source.index,
            result.destination.index
        );

        const  userEdit = {
            buttons: accountType === "basic" ? buttonsActiveState(items,buttons) : items
        };
        
        setButtonState(userEdit.buttons);
        await updateVcardObject(userEdit, uid).then(async () => {
            await getUpdatedUserVcard();
        });
    };

    //---------------- End Drag and Drop ----------------//
    // console.log(messaging);
    
    if (profile_theme !== undefined) {
        return (
            <>
            <div className='bottom-card' style={{background: profile_theme.btm_card_color, fontFamily: profile_theme.font}}>
                <div className="bottom-card-top-btns">
                    <div className='bottom-card-download-btn' id='download-contact' disabled style={{background: profile_theme.btn_color, color: profile_theme.btm_text_color, borderColor: profile_theme.btm_text_color }}>
                        <i className='far fa-arrow-circle-down' aria-hidden='true'></i>
                        {window.innerWidth <= 768 ? 
                            "Download"
                            :
                            "Download Contact"
                        }
                    </div>
                    {messaging?.enabled ? <div className='bottom-card-message-btn' disabled style={{background: profile_theme.btn_color, color: profile_theme.btm_text_color, borderColor: profile_theme.btm_text_color}}><i className='fa fa-envelope' aria-hidden='true'></i></div> : <></>}
                </div>
                {(buttons && buttons?.length > 0) ?
                    // <DragDropContext onDragEnd={onDragEnd}>
                    //     <Droppable droppableId='droppable' >
                    //     {(provided, snapshot) => (
                    //         <div className='bottom-card-btns' {...provided.droppableProps} ref={provided.innerRef}  >
                    //             {buttons && buttons.map((button, index) => ( 
                    //                 <Draggable key={button.added.toString()} draggableId={button.added.toString()} index={index} disableInteractiveElementBlocking isDragDisabled={!permissions.edit_button} >
                    //                 {(provided, snapshot) => (
                    //                     <div ref={provided.innerRef} {...provided.draggableProps} className={button.active === false ? 'draggable-btns draggable-btns-inactive' : (accountType === 'basic') ? 'draggable-btns' : null}>
                    //                         <button  {...provided.dragHandleProps} className='bottom-card-btn' style={button.icon !== '' ? {background: 'linear-gradient(to right, transparent 8%, ' + profile_theme.btn_color + ' 20%, ' + profile_theme.btn_color + ')', border: snapshot.isDragging && '2px solid white', boxShadow: snapshot.isDragging && '.2rem .2rem .4rem rgba(0,0,0,.9)', cursor: style.cursor} : {background: profile_theme.btn_color, border: snapshot.isDragging && '2px solid white', boxShadow: snapshot.isDragging && '.2rem .2rem .4rem rgba(0,0,0,.9)', cursor: style.cursor}} onClick={permissions.edit_button !== false ? (e) => {e.preventDefault(); editButton(button);} : (e) => e.preventDefault()}>
                    //                             <div className='bottom-card-icons'>
                    //                                 {button.icon && <i className={button.icon} style={{background: profile_theme.icon_color}}></i>}
                    //                             </div>
                    //                             <div className='bottom-card-links'> 
                    //                                 <h4 className='bottom-card-link-name' style={{color: profile_theme.btm_text_color}}>{button.label === undefined || button.label === '' ? button.ref === 'phone' ? "Work Phone" : button.ref.charAt(0).toUpperCase() + button.ref.slice(1) : button.label}</h4>
                    //                             </div>
                    //                             <div className='bottom-card-arrow'>
                    //                                 <i className='fas fa-grip-vertical' style={{color: profile_theme.btm_text_color}}></i>
                    //                             </div>
                    //                         </button>
                    //                     </div>
                    //                 )}
                    //                 </Draggable>
                    //             ))}
                    //             {provided.placeholder}
                    //             {permissions.edit_button ?
                    //                 <button className='bottom-card-btn bottom-card-add-btn' onClick={(e) => {e.preventDefault(); setShowForm('add-button')}} style={{fontFamily: "'franklin_gothic_bookregular', sans-serif"}}>
                    //                     <div className='bottom-card-icons'>
                    //                     </div>
                    //                     <div className='bottom-card-links'> 
                    //                         <h4 className='bottom-card-link-name'>Add a Button <i className='fas fa-plus' /></h4>
                    //                     </div>
                    //                     <div className='bottom-card-arrow'>
                    //                     </div>
                    //                 </button>
                    //                 :
                    //                 <></>
                    //             }
                    //         </div>
                    //     )}
                    //     </Droppable>
                    // </DragDropContext>
                    <></>
                    : 
                        <>
                            {permissions.edit_button ?
                                <button className='bottom-card-btn bottom-card-add-btn' onClick={(e) => {e.preventDefault(); setShowForm('add-button')}} style={{fontFamily: "'franklin_gothic_bookregular', sans-serif"}}>
                                    <div className='bottom-card-icons'>
                                    </div>
                                    <div className='bottom-card-links'> 
                                        <h4 className='bottom-card-link-name'>Add a Button <i className='fas fa-plus' /></h4>
                                    </div>
                                    <div className='bottom-card-arrow'>
                                    </div>
                                </button>
                                :
                                <></>
                            }
                        </>
                }
            </div>
            {(accountType === 'basic' && buttons?.length > 5) &&
                <OverlayTrigger
                    placement='top'
                    trigger={['hover','click']}
                    delay={{show: 0, hide: 3000}}
                    overlay={<Tooltip className='theme-builder-top'>Basic plans are limited to 5 buttons. Upgrade to <a href='/upgrade' style={{fontWeight: 'bold', color: '#fff'}}>Pro</a> to utilize all of your buttons!</Tooltip>}
                >
                    <div className='bottom-card-basic-btn-info'>
                        <i className='far fa-circle-info' style={{fontSize: '1.5rem'}} />
                        <p className='mb-0'>Why don't all of my buttons show on my Digital Business Card?</p>
                    </div>
                </OverlayTrigger>
            }
            </>
        );
    } else {
        <></>
    }
};

export default BottomCard;